import { Icon, IconButton, Input, TextArea } from 'native-base';
import React, { FC, useCallback, useEffect } from 'react';
import { Alert, StyleSheet } from 'react-native';
import { ElementBase, IElementBaseProps, initializeElement } from '..';
import { Feather,  } from "@expo/vector-icons";
import { Box, Text, } from "@gluestack-ui/themed"
import { MarkdownText } from '../base/renderMDText';
import { TouchableOpacity } from 'react-native';
import { useVoiceDictation } from '../../utils/useVoiceDictation';

export const TextElement: FC<IElementBaseProps> = (({ ...props }) => {
    const {
        element,
        payload, checkAndSetPayload, errorList
    } = initializeElement(props);

    const handleChange = useCallback((value: string | undefined) => {
        let val = value === undefined ? "" : value.toString();
        if (element.templateData.toChangeCase === "upperCase")
            val = val.toUpperCase();
        if (element.templateData.toChangeCase === "lowerCase")
            val = val.toLowerCase();        
        checkAndSetPayload(val);
    }, []);
    
    if (element.templateData.valueAsTitle && element.templateData.readOnly ){
        element.name=payload.value;
        return <ElementBase errors={errorList} element={element} forReview={props.forReview} link={payload.url}></ElementBase>
    }
    const { 
        isListening, 
        startListening, 
        stopListening, 
        errorType, 
        isSupported 
    } = useVoiceDictation(handleChange);

    useEffect(() => {
        if (errorType === 'NETWORK_ERROR') {
            Alert.alert(
                "Dictado ",
                "Manten apretado mientras dictas.\n\nOFFLINE\nPara usar voz sin conexión, descarga el paquete de español en los ajustes de idioma de tu dispositivo."
            );
        }
        
        console.log("errorType", errorType)
    }, [errorType]);
    const micPress = () => {
        startListening((txt:any)=>{
            handleChange(((payload.value||"").concat(" ").concat(txt)))
        });
    }
;
    const dicButton= isSupported && element.type != "sendemail"? 
            <IconButton key="recAudio" size="lg" onPressIn={micPress} onPressOut={stopListening} icon={<Icon as={Feather} name="mic" size="lg" />} /> 
            : null;
    
    return <ElementBase errors={errorList} element={element} forReview={props.forReview} link={payload.url} changedMe={payload.value} rightButton={dicButton}>
        {props.forReview || element.templateData.readOnly ?
            <Text style={{ color: (element.templateData.textColor ? element.templateData.textColor : "#000") }} size='md'>
                <MarkdownText parser={element.templateData.hasMarkDown ?? false}>{(payload.value)}</MarkdownText>
            </Text>
            :
            <Box>
                {(element.templateData.rowSpan == undefined || element.templateData.rowSpan == 1) ?
                    <Box><Input variant="unstyled" size={"md"}
                        InputLeftElement={element.type == "sendemail" ?<Icon as={Feather} mr="3" name="at-sign" size="md" />:<></>}
                        isReadOnly={element.templateData.readOnly ? true : false}
                        keyboardType={element.type == "sendemail" ? "email-address" : "default"}
                        color={element.templateData.textColor || "#000"}
                        fontWeight={element.templateData.hidden_label ? "bold":"normal"}
                        onChangeText={handleChange}
                        placeholder={element.templateData.placeholder || ""}
                        value={payload.value?.toString() || ""}
                        backgroundColor={isListening ? "danger.400" :element.templateData.readOnly ? undefined: "#00000010"}
                        maxLength={element.templateData.maxLength}
                    />
                        
                    </Box>
                    :
                    <Box><TextArea
                        maxLength={element.templateData.maxLength}
                        variant={element.templateData.readOnly ? "unstyled" : "filled"}
                        isReadOnly={element.templateData.readOnly ? true : false}
                        multiline={true} fontSize={"md"}
                        numberOfLines={element.templateData.rowSpan}
                        keyboardType={element.type == "sendemail" ? "email-address" : "default"}
                        color={element.templateData.textColor || "#000"}
                        onChangeText={handleChange}
                        placeholder={element.templateData.placeholder || ""}
                        value={payload.value?.toString() || ""}
                        autoCompleteType="default" backgroundColor={isListening ? "danger.400" :element.templateData.readOnly ? undefined : "#00000010"}/></Box>
                }
            </Box>
        }
    </ElementBase>
});
